import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TransactionSummaryDto } from '@workspace/data-types';
import { AvatarAuraComponent, LuxonDatePipe } from '@workspace/ng-aura';
import { PriceDisplayPipe, TransactionStatusDisplayPipe } from '@workspace/ng-data-access';

@Component({
  selector: 'core-transaction-details',
  templateUrl: './transaction-details.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TransactionStatusDisplayPipe,
    PriceDisplayPipe,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    LuxonDatePipe,
    AvatarAuraComponent,
    SlicePipe,
    RouterModule,
  ],
})
export class TransactionDetailsCoreComponent {
  transaction = input.required<TransactionSummaryDto>();
}
